import React, { useState } from "react";
import { Box, Typography, Input, Button, Alert } from "@mui/joy";
import { Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import apiService from "../services/api";

const SearchPage: React.FC = () => {
  const [citizenId, setCitizenId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!citizenId || citizenId.length !== 13) {
      setError("กรุณากรอกเลขบัตรประจำตัวประชาชน 13 หลัก");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await apiService.searchCandidate(citizenId);
      if (response.success) {
        // Navigate to candidate detail page with the data
        navigate(`/candidate/${citizenId}`, {
          state: { candidateData: response.data },
        });
      } else {
        setError(response.error || "ไม่พบข้อมูลผู้สมัคร");
      }
    } catch (error: any) {
      console.error("Search error:", error);
      if (error.response?.status === 404) {
        setError("ไม่พบข้อมูลผู้สมัครด้วยเลขบัตรประจำตัวประชาชนนี้");
      } else {
        setError("เกิดข้อผิดพลาดในการค้นหา กรุณาลองใหม่อีกครั้ง");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography level="h2" sx={{ mb: 2 }}>
        ค้นหาผู้สมัคร
      </Typography>
      <Typography level="body-md" sx={{ mb: 3 }}>
        กรอกเลขบัตรประจำตัวประชาชน 13 หลัก เพื่อค้นหาข้อมูลผู้สมัคร MP101
      </Typography>

      {error && (
        <Alert color="danger" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <form onSubmit={handleSearch}>
        <Box sx={{ mb: 2, maxWidth: 400 }}>
          <Input
            placeholder="กรอกเลขบัตรประจำตัวประชาชน 13 หลัก"
            value={citizenId}
            onChange={(e) =>
              setCitizenId(e.target.value.replace(/\D/g, "").slice(0, 13))
            }
            size="lg"
            error={!!error}
          />
        </Box>

        <Button
          type="submit"
          loading={loading}
          startDecorator={<SearchIcon />}
          size="lg"
          disabled={citizenId.length !== 13}
        >
          {loading ? "กำลังค้นหา..." : "ค้นหา"}
        </Button>
      </form>
    </Box>
  );
};

export default SearchPage;
